import PageLevelProposal from "../page/PageLevelProposal";

export default [
  {
    path: "/level-proposal",
    Component: PageLevelProposal,
  },
];
